import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useQuery } from '@tanstack/react-query';
import { IOpioidDrugRouteCombination } from '../MME.ts';
import { MMEApi } from '../../../apis/MMEApi/MMEApi.ts';

export function useGetMMEDrugRouteCombinations(versionID?: number) {
    return useQuery<IOpioidDrugRouteCombination[]>({
        queryKey: [QueryKeys.mmeDrugRouteCombinations, versionID],
        queryFn: async () => {
            return await MMEApi.getDrugRouteCombinations(versionID);
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
}

